<template>
	<div class="archive" style="padding: 5px 10px">
		<h1>網路連線遊戲服務定型化契約</h1>

		<div class="note">
			<p>為保障您使用本遊戲網路連線遊戲服務的相關權益，請於註冊登記使用本遊戲之服務前，詳細閱讀本契約之所有規定。請您務必詳細閱讀並經三（3）日以上審閱，以保障您的權益</p>
		</div>

		<div class="contract-info">
			<h3>立契約書人</h3>
			<p>消費者（以下簡稱「甲方」，請依會員註冊流程填寫）</p>

			<div class="company-info">
				<p>企業經營者名稱：易亨數位行銷有限公司（以下簡稱「乙方」）</p>
				<p>代表人：羅郁晴</p>
				<p>聯絡人：張先生</p>
				<p>營業所地址：台北市信義區光復南路495號7樓之6</p>
				<p>統一編號：52469259</p>
			</div>
		</div>

		<div class="clause">
			<h2>第一條　　法定代理人</h2>
			<p>甲方為限制行為能力人者，本契約訂定時，應經甲方之法定代理人同意，本契約始生效力；甲方為無行為能力人者，本契約之訂定，應由甲方之法定代理人代為之。</p>
			<p>若有限制行為能力人未經同意或無行為能力人未由法定代理人代為付費購買點數致生法定代理人主張退費時，法定代理人得依官網公告流程，備妥證明文件並提出申請，經乙方確認後，退還甲方未使用之遊戲費用。</p>
			<p>乙方應於官網首頁、遊戲登入頁面或購買頁面以中文明顯標示，若甲方為限制行為能力人或無行為能力人，除應符合第一項規定外，並應於甲方之法定代理人閱讀、瞭解並同意本契約之所有內容後，方得使用本遊戲服務，本契約條款變更時亦同。
			</p>
		</div>

		<div class="clause">
			<h2>第二條　　契約適用之範圍</h2>
			<p>乙方提供甲方網路連線遊戲服務及其他相關服務（以下簡稱本遊戲服務），甲乙雙方關於本遊戲服務之權利義務，依本契約條款之約定定之。</p>
		</div>

		<div class="clause">
			<h2>第三條　　契約之內容</h2>
			<p>以下視為本契約之一部分，與本契約條款具有相同之效力：</p>
			<ol>
				<li>乙方有關本遊戲服務之廣告或宣傳內容。</li>
				<li>計費制遊戲之費率表及遊戲管理規則。</li>
			</ol>
			<p>本契約條款如有疑義時，應為甲方有利之解釋。</p>
		</div>

		<div class="clause">
			<h2>第四條　　名詞定義</h2>
			<p>本契約之名詞定義如下：</p>
			<ol>
				<li>網路連線遊戲：係指甲方透過電腦、智慧型裝置或其他電子化載具，連結網際網路至乙方指定之伺服器所進行連線遊戲。但不包括電子遊戲場業管理條例所稱電子遊戲機、單純區域連線或其他無需透過網路連結遊戲伺服器之遊戲服務。
				</li>
				<li>遊戲網站：係指由乙方為提供本遊戲服務所建置之網站。</li>
				<li>遊戲管理規則：係指由乙方訂立，供為規範遊戲進行方式之規則且不影響雙方契約上之權利義務者。</li>
				<li>遊戲歷程：係指自甲方登入本遊戲起至登出本遊戲時止，電腦系統對甲方遊戲進行過程所為之紀錄。</li>
				<li>外掛程式：係指非由乙方提供，以影響或改變乙方網路連線遊戲運作為目的之程式。</li>
			</ol>
		</div>

		<div class="clause">
			<h2>第五條　　服務範圍</h2>
			<p>本契約所提供之遊戲服務，係由乙方指定之伺服器，讓甲方透過網際網路連線登入使用本遊戲服務。但不包括甲方向網際網路接取服務業者申請接取網際網路之服務，及提供上網所需之各項硬體設備。</p>
		</div>

		<div class="clause">
			<h2>第六條　　遊戲登錄</h2>
			<p>甲方申請使用本遊戲服務，應依申請流程，於遊戲網站登錄與身分證明文件相符之個人資料或其他必要資訊。為確保甲方使用本遊戲服務之權益，甲方提供之資料應可驗證身分，若有不正確或已變更時，應立即通知乙方更新。</p>
			<p>乙方若有為提供本遊戲服務與甲方聯絡之必要，而甲方未提供正確之個人資料或原提供之資料不符合真實且未更新，乙方得於甲方提供真實資料或更新資料前，暫停甲方遊戲進行及遊戲歷程查詢之服務。但甲方能證明其為契約當事人者，不在此限。
			</p>
		</div>

		<div class="clause">
			<h2>第七條　　契約解除權規定</h2>
			<p>甲方得於開始遊戲後七日內，以書面告知乙方解除本契約，甲方無需說明理由及負擔任何費用。</p>
			<p>前項情形，甲方得就未使用之付費購買點數向乙方請求退費。</p>
		</div>

		<div class="clause">
			<h2>第八條　　計費方式</h2>
			<p>本遊戲服務之收費計算方式為：</p>
			<p><span class="checkbox">☑</span>免費制</p>
			<p><span class="checkbox">□</span>計時制（應敘明計價單位及幣別，計價單位最高不得逾二小時）</p>
			<p><span class="checkbox">□</span>其他費制<span class="highlight">__________</span></p>
			<p>本遊戲服務內（例如：遊戲商城、線上商店等）有提供需甲方額外付費購買之點數、商品或其他服務（例如：虛擬貨幣或寶物、進階道具等），乙方應在官網首頁、遊戲登入頁面或購買頁面公告載明付款方式及商品資訊。</p>
			<p>費率調整時，乙方應於預定調整生效日三十日前於官網首頁、遊戲登入頁面或購買頁面公告；若甲方於註冊帳號時已登錄通訊資料者，並依甲方登錄之通訊資料通知甲方。</p>
			<p>費率如有調整時，應自調整生效日起按新費率計收；若新費率高於舊費率時，甲方在新費率生效日前已於官網中登錄之付費購買點數或遊戲費用應依舊費率計收。</p>
		</div>

		<div class="clause">
			<h2>第九條　　本遊戲服務應載明之資訊</h2>
			<p>乙方應於官網首頁、遊戲登入頁面或購買頁面及遊戲套件包裝上載明以下事項：</p>
			<ol>
				<li>依遊戲軟體分級管理辦法規定標示遊戲分級級別及禁止或適合使用之年齡層。</li>
				<li>進行本遊戲服務之最低軟硬體需求。</li>
				<li>有提供安全裝置者，其免費或付費資訊。</li>
				<li>有提供付費購買之機會中獎商品或活動，其活動內容、獎項、中獎及機率或稀有商品數量等資訊，並應記載「此為機會中獎商品，消費者購買或參與活動不代表即可獲得特定商品」等提示。</li>
			</ol>
		</div>

		<div class="clause">
			<h2>第十條　　帳號與密碼之使用</h2>
			<p>甲方完成註冊程序後取得之帳號及密碼，僅供甲方使用。</p>
			<p>前項之密碼得依乙方提供之修改機制進行變更。乙方人員（含客服人員、遊戲管理員）不得主動詢問甲方之密碼。乙方應於契約終止後三十日內（不得低於三十日），保留甲方之帳號及附隨於該帳號之電磁紀錄。</p>
			<p>契約非因可歸責甲方之事由而終止者，甲方於前項期間內辦理續用後，有權繼續使用帳號及附隨於該帳號之電磁紀錄。</p>
			<p>第二項期間屆滿時，甲方仍未辦理續用，乙方得刪除該帳號及附隨於該帳號之所有資料，但法令另有規定者不在此限。</p>
		</div>

		<div class="clause">
			<h2>第十一條　　帳號密碼遭非法使用之通知與處理</h2>
			<p>當事人一方如發現帳號、密碼被非法使用時，應立即通知對方並由乙方進行查證，經乙方確認有前述情事後，得暫停該組帳號或密碼之使用權，更換帳號或密碼予甲方，立即限制第三人就本遊戲服務之使用權利，並將相關處理方式揭載於遊戲管理規則。
			</p>
			<p>乙方應於暫時限制遊戲使用權利之時起，即刻以官網公告、簡訊、電子郵件、推播或其他雙方約定之方式通知前項第三人提出說明。如該第三人未於接獲通知時起七日內提出說明，乙方應直接回復遭不當移轉之電磁紀錄予甲方，如不能回復時可採其他雙方同意之相當補償方式，並於回復後解除對第三人之限制。但乙方有提供免費安全裝置（例如：防盜卡、電話鎖等）而甲方不使用或有其他可歸責於甲方之事由，乙方不負回復或補償責任。
			</p>
			<p>第一項之第三人不同意乙方前項之處理時，甲方得依報案程序，循司法途徑處理。</p>
			<p>乙方依第一項規定限制甲方或第三人之使用權時，在限制使用期間內，乙方不得向甲方或第三人收取費用。</p>
			<p>甲方如有申告不實之情形致生乙方或第三人權利受損時，應負一切法律責任。</p>
		</div>

		<div class="clause">
			<h2>第十二條　　遊戲歷程之保存與查詢</h2>
			<p>乙方應保存甲方之個人遊戲歷程紀錄，且保存期間為三十日（不得低於三十日），以供甲方查詢。</p>
			<p>甲方得以書面、網路，或親至乙方之服務中心申請調閱甲方之個人遊戲歷程，且須提出與身分證明文件相符之個人資料以供查驗，查詢費用如下，由甲方負擔：</p>
			<p><span class="checkbox">□</span>免費。</p>
			<p><span class="checkbox">☑</span><span class="highlight">二百</span>元（不得超過新臺幣二百元）。</p>
			<p><span class="checkbox">□</span>其他計費方式（計費方式另行公告於官網首頁、遊戲登入頁面或購買頁面，其收費不得超過新臺幣二百元）。</p>
			<p>乙方接獲甲方之查詢申請，應提供第一項所列之甲方個人遊戲歷程，並於七日內以儲存媒介或書面、電子郵件方式提供資料。</p>
		</div>

		<div class="clause">
			<h2>第十三條　　個人資料</h2>
			<p>關於個人資料之保護，依相關法律規定處理。</p>
		</div>

		<div class="clause">
			<h2>第十四條　　電磁紀錄</h2>
			<p>本遊戲之所有電磁紀錄均屬乙方所有，乙方並應維持甲方相關電磁紀錄之完整。</p>
			<p>甲方對於前項電磁紀錄有使用支配之權利。但不包括本遊戲服務範圍外之移轉、收益行為。</p>
		</div>

		<div class="clause">
			<h2>第十五條　　資訊公開</h2>
			<p>乙方應於遊戲網站上提供本遊戲服務之伺服器可容納人數、同時上線人數與連線狀況等相關資訊，並定期更新。</p>
		</div>

		<div class="clause">
			<h2>第十六條　　連線品質</h2>
			<p>乙方為維護本遊戲服務相關系統及軟硬體設備而預先規劃暫停本遊戲服務之全部或一部時，應於七日前於官網首頁、遊戲登入頁面或購買頁面公告。但因臨時性、急迫性或不可歸責於乙方之事由者，不在此限。</p>
			<p>因可歸責乙方事由，致甲方不能連線使用本遊戲服務時，乙方應立即更正或修復。對於甲方於無法使用期間遭扣除遊戲費用或遊戲內商品，乙方應返還遊戲費用或商品，無法返還時則應提供其他合理之補償。</p>
		</div>

		<div class="clause">
			<h2>第十七條　　企業經營者及消費者責任</h2>
			<p>乙方應依本契約之規定負有於提供本服務時，維護其自身電腦系統，符合當時科技或專業水準可合理期待之安全性。</p>
			<p>電腦系統或電磁紀錄受到破壞，或電腦系統運作異常時，乙方應於採取合理之措施後儘速予以回復。</p>
			<p>乙方違反前二項規定或因遊戲程式漏洞致生甲方損害時，應依甲方受損害情形，負損害賠償責任。但乙方能證明其無過失者，得減輕其賠償責任。</p>
			<p>乙方電腦系統發生第二項所稱情況時，於完成修復並正常運作之前，乙方不得向甲方收取費用。</p>
			<p>甲方因共用帳號、委託他人付費購買點數衍生與第三人間之糾紛，乙方得不予協助處理。</p>
		</div>

		<div class="clause">
			<h2>第十八條　　遊戲管理規則</h2>
			<p>為規範遊戲進行之方式，乙方應訂立合理公平之遊戲管理規則，甲方應遵守乙方公告之遊戲管理規則。</p>
			<p>遊戲管理規則之變更應依第二十一條之程序為之。</p>
			<p>遊戲管理規則有下列情形之一者，其規定無效：：</p>
			<ol>
				<li>牴觸本契約之規定。</li>
				<li>剝奪或限制甲方之契約上權利。但乙方依第十九條之規定處理者，不在此限。</li>
			</ol>
		</div>

		<div class="clause">
			<h2>第十九條　　違反遊戲管理規則之處理</h2>
			<p>除本契約另有規定外，有事實足證甲方於本遊戲服務中違反遊戲管理規則時，乙方應於官網首頁、遊戲登入頁面或購買頁面公告，並依甲方登錄之通訊資料通知甲方。</p>
			<p>甲方第一次違反遊戲管理規則，乙方應通知甲方於一定期間內改善。經乙方通知改善而未改善者，乙方得依遊戲管理規則，按其情節輕重限制甲方之遊戲使用權利。如甲方因同一事由再次違反遊戲管理規則時，乙方得立即依遊戲管理規則限制甲方進行遊戲之權利。
			</p>
			<p>乙方依遊戲管理規則限制甲方進行遊戲之權利，每次不得超過<span class="highlight">七</span>日（至長不得超過七日）。</p>
		</div>

		<div class="clause">
			<h2>第二十條　　申訴權利</h2>
			<p>甲方不滿意乙方提供之連線品質、遊戲管理、費用計費、其他相關之服務品質，或對乙方依遊戲管理規則之處置不服時，得於收到通知之翌日起七日內至乙方之服務中心或以電子郵件或書面提出申訴，乙方應於接獲申訴後，於<span
					class="highlight">十五</span>日（至長不得超過十五日）內回覆處理之結果。</p>
			<p>乙方應於官網或遊戲管理規則中明定服務專線、電子郵件等相關聯絡資訊與二十四小時申訴管道。</p>
			<p>甲方反映第三人利用外掛程式或其他影響遊戲公平性之申訴，依第一項規定辦理。</p>
		</div>

		<div class="clause">
			<h2>第二十一條　　契約之變更</h2>
			<p>乙方修改本契約時，應於官網首頁、遊戲登入頁面或購買頁面公告之，並依甲方登錄之通訊資料通知甲方。</p>
			<p>乙方未依前項進行公告及通知者，其契約之變更無效。</p>
			<p>甲方於第一項通知到達後十五日內：</p>
			<ol>
				<li>甲方未為反對之表示者，乙方依契約變更後之內容繼續提供本遊戲服務。</li>
				<li>甲方為反對之表示者，依甲方終止契約方式處理。</li>
			</ol>
		</div>

		<div class="clause">
			<h2>第二十二條　　契約之終止及退費</h2>
			<p>甲方得隨時通知乙方終止本契約。</p>
			<p>乙方得與甲方約定，若甲方逾<span
					class="highlight">一年</span>期間（不得少於一年）未登入使用本遊戲服務，乙方得定相當期限（不得少於十五日）通知甲方登入，如甲方屆期仍未登入使用，則乙方得終止本契約。</p>
			<p>甲方有下列重大情事之一者，乙方依甲方登錄之通訊資料通知甲方後，得立即終止本契約：</p>
			<ol>
				<li>利用任何系統或工具對乙方電腦系統之惡意攻擊或破壞。</li>
				<li>以利用外掛程式、病毒程式、遊戲程式漏洞或其他違反遊戲常態設定或公平合理之方式進行遊戲。</li>
				<li>以冒名、詐騙或其他虛偽不正等方式付費購買點數或遊戲內商品。</li>
				<li>因同一事由違反遊戲管理規則達一定次數（不得少於三次）以上，經依第十九條第二項通知改善而未改善者。</li>
				<li>經司法機關查獲從事任何不法之行為。</li>
			</ol>
			<p>乙方對前項事實認定產生錯誤或無法舉證時，乙方應對甲方之損害負賠償責任。</p>
			<p>契約終止時，乙方於扣除必要成本後，應於三十日內以現金、信用卡、匯票或掛號寄發支票方式退還甲方未使用之付費購買之點數或遊戲費用，或依雙方同意之方式處理前述點數或費用。</p>
		</div>

		<div class="clause">
			<h2>第二十三條　　停止營運</h2>
			<p>因乙方停止本遊戲服務之營運而終止契約者，應於停止終止前<span
					class="highlight">三十</span>日（不得少於三十日）公告於官網首頁、遊戲登錄頁面或購買頁面，並依甲方登錄之通訊資料通知甲方。</p>
			<p>乙方未依前項期間公告並通知，除應退還甲方未使用之付費購買點數或遊戲費用且不得扣除必要成本外，並應提供其他合理之補償。</p>
		</div>

		<div class="clause">
			<h2>第二十四條　　送達</h2>
			<p>有關本契約所有事項之通知，甲方同意乙方依甲方登錄之通訊資料為送達。</p>
			<p>前項登錄通訊資料若有變更，甲方應即通知乙方。乙方應依變更後之通訊資料為送達。</p>
			<p>乙方依甲方登錄之通訊資料所為之通知發出後，以書面通知到達甲方，或電子郵件進入甲方之電子郵件伺服器中，推定為已送達。</p>
			<p>因甲方之故意或過失致乙方無法為送達者，乙方對甲方因無法送達所致之損害不負賠償責任。</p>
		</div>

		<div class="clause">
			<h2>第二十五條　　準據法</h2>
			<p>本契約以中華民國法律為準據法。</p>
		</div>

		<div class="clause">
			<h2>第二十六條　　管轄法院</h2>
			<p>因本契約而生之事件，雙方合意以士林地方法院為第一審管轄法院。</p>
			<p>前項約定不得排除消費者保護法第四十七條及民事訴訟法第二十八條第二項、第四百三十六條之九規定之適用。</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ArchiveEN'
}
</script>

<style scoped>
.archive {
	font-family: "Microsoft JhengHei", sans-serif;
	line-height: 1.6;
	max-width: 800px;
	margin: 0 auto;
	padding: 20px;
}

h1 {
	text-align: center;
	color: #333;
	border-bottom: 2px solid #4a86e8;
	padding-bottom: 10px;
}

h2 {
	color: #444;
	margin-top: 30px;
	border-left: 4px solid #4a86e8;
	padding-left: 10px;
}

h3 {
	color: #555;
	margin-top: 20px;
}

p {
	text-align: justify;
}

.contract-info {
	background-color: #f0f8ff;
	padding: 15px;
	border-radius: 5px;
	margin: 20px 0;
}

.company-info {
	margin-top: 15px;
}

.highlight {
	background-color: #ffffcc;
	padding: 2px 5px;
}

.signature {
	margin-top: 40px;
	text-align: right;
}

.clause {
	margin-bottom: 25px;
}

.checkbox {
	font-size: 1.2em;
	margin-right: 5px;
}

.note {
	color: #d32f2f;
	font-weight: bold;
}
</style>